import { axiosInstance } from './api';

export default {
  getTimelinesAlertsByGalpon: data => {
    return axiosInstance.get('/timelines?id=' + data.id);
  }
};
